import {useTranslation} from '@aboutyou/i18n';
import {
  SortFlyout as SortFlyoutBase,
  SortFlyoutSortOptions,
  SortingOption,
} from '@aboutyou/ui-components';
import React from 'react';
import {useSorting} from '../../ProductStream/utils';
import {useSortFlyoutOpenedState} from './hooks/useSortFlyoutOpenedState';

interface CategorySortFlyoutProps {
  sortingOptions: SortingOption[];
  defaultSortingOptionId: string;
  onSort?: () => void;
  renderInPortal?: boolean;
  onClose?: () => void;
  shouldTrackImmediately?: boolean;
}

export const SortFlyout: React.FC<CategorySortFlyoutProps> = props => {
  const {cancel: closeFlyout, submit, isOpen} = useSortFlyoutOpenedState();
  const {
    sortingOptions,
    onSort,
    renderInPortal,
    defaultSortingOptionId,
    onClose,
    shouldTrackImmediately,
  } = props;
  const {t} = useTranslation();
  const {sorting, setSorting} = useSorting();

  const handleClose = () => {
    onClose?.();
    closeFlyout();
  };

  const handleSort = (optionId: string) => {
    onSort?.();
    setSorting(optionId, {
      shouldTrackImmediately,
      shouldScrollToTop: true,
    });
  };

  return (
    <SortFlyoutBase
      title={t('Sort')}
      open={isOpen}
      onClose={handleClose}
      renderInPortal={renderInPortal}
    >
      <SortFlyoutSortOptions
        activeOptionId={sorting ?? defaultSortingOptionId}
        onSelect={handleSort}
        options={sortingOptions}
        primaryButtonLabel={t('Confirm')}
        onPrimaryButtonClick={submit}
      />
    </SortFlyoutBase>
  );
};
